import {useMutation} from '@apollo/client/react';
import {extractGqlData} from '@coolcolduk/ui-apollo-client';
import {Base64ObjectInput, Question} from '@cp/model';
import {CREATE_QUESTION} from '../sharedQueries';

export function useCreateQuestion() {
  const [createQuestionMutation, {loading, error}] = useMutation<
    {createQuestion: Question},
    {
      moduleId: string;
      topic: string;
      difficulty: number;
      questionText: string;
      options: string[];
      answer: string;
      explanation: string;
      hint?: string;
      image?: Base64ObjectInput | null;
      graphJsonString?: string;
      seedQuestionId?: string;
    }
  >(CREATE_QUESTION);

  const createQuestion = async (
    moduleId: string,
    topic: string,
    difficulty: number,
    questionText: string,
    options: string[],
    answer: string,
    explanation: string,
    hint?: string,
    image?: Base64ObjectInput | null,
    graphJsonString?: string,
    seedQuestionId?: string,
  ) => {
    const result = await createQuestionMutation({
      variables: {
        moduleId,
        topic,
        difficulty,
        questionText,
        options,
        answer,
        explanation,
        hint,
        image: image || undefined,
        graphJsonString,
        seedQuestionId,
      },
      // refetchQueries: [
      //   {
      //     query: LIST_QUESTIONS,
      //     variables: {moduleId},
      //   },
      // ],
    });

    return extractGqlData(result).createQuestion;
  };

  return {
    createQuestion,
    loading,
    error,
  };
}
